<template>
  <div class="relative">
    <div @click="forceClose" :class="{ enabled: is_fixed }" class="outside_background"></div>
    <transition name="fade">
      <div v-if="show_tooltip" class="tooltip is-flex is-align-items-center is-justify-content-center">
        <img @click="updateApplicant({ is_star: 1 })" src="/is_star_full.png" class="tooltip_img">
        <div style="width: 10px"></div>
        <img @click="updateApplicant({ is_star: 0 })" src="/is_star_purple.png" class="tooltip_img">
        <div style="width: 10px"></div>
        <img  @click="updateApplicant({ is_star: -1 })" src="/is_star_not_full.png" class="tooltip_img">
      </div>
    </transition>
    <img
      @click="setFixed()"
      @mouseover="onMouseOver"
      @mouseleave="onMouseLeave"
      class="operation_icon is_star_image"
      :src="getSelectedImage()"
    />
  </div>
</template>
<script>
export default {
  name: 'is-star',
  props: ['payload'],
  data () {
    return {
      is_fixed: false,
      show_tooltip: false,
      is_star: this.payload.resource.applicant.is_star
    }
  },
  methods: {
    getSelectedImage () {
      if (this.is_star == 1) {
        return '/is_star_full.png'
      }
      if (this.is_star == 0) {
        return '/is_star_purple.png'
      }
      return '/is_star_not_full.png'
    },
    onMouseOver () {
      this.show_tooltip = true
    },
    onMouseLeave () {
      if (this.is_fixed) {
        return
      }
      this.show_tooltip = false
    },
    forceClose () {
      this.is_fixed = false
      this.show_tooltip = false
    },
    updateApplicant (params) {
      this.$network_utils.updateApplicant({ applicant_id: this.payload.resource_id, ...params }).then(() => {
        this.is_star = params.is_star
        this.$utils.emit('show_toast', { text: 'כוכב עודכן' })
        this.forceClose()
      })
    },
    setFixed () {
      this.is_fixed = true
    }
  }
}
</script>
<style scoped>
  .outside_background{
    position: fixed;
    pointer-events: none;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
  }
  .enabled{
    pointer-events: auto !important;
  }
  .tooltip{
    position: absolute;
    box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
    background-color: #f9f9f9;
    border-radius: 20px;
    left: -50px;
    top: -40px;
    width: 130px;
    height: 40px;
  }
  .tooltip_img{
    cursor: pointer;
    min-width: 20px !important;
    width: 20px !important;
  }
  .is_star_image{
    max-width: 30px !important;
  }
</style>
